import { add } from "./base";
class Handler {
    min;
    max;
    pad;
    constructor(options) {
        this.min = options.min;
        this.max = options.max;
        this.pad = options.pad;
    }
    toString(data) {
        return typeof data == "number" ? data.toString() : "";
    }
    fromString(value) {
        const parsed = typeof value == "string" ? Number.parseInt(value) : undefined;
        return typeof parsed == "number" && !Number.isNaN(parsed) ? parsed : undefined;
    }
    partialFormat(unformatted) {
        return {
            ...unformatted,
            type: "text",
            inputmode: "numeric",
            length: [3, undefined],
            pattern: /^[0-9]+$/,
        };
    }
    format(unformatted) {
        const result = this.partialFormat(unformatted);
        const number = this.fromString(result.value);
        const value = number == undefined
            ? result.value
            : this.min != undefined && number < this.min
                ? this.toString(this.min)
                : this.max != undefined && number > this.max
                    ? this.toString(this.max)
                    : result.value;
        return {
            ...result,
            value: typeof this.pad == "number" && value ? value.padStart(this.pad, "0") : value,
        };
    }
    unformat(formatted) {
        return formatted;
    }
    allowed(symbol, state) {
        return (symbol >= "0" &&
            symbol <= "9" &&
            (this.max == undefined ||
                this.max.toString().length > state.value.length ||
                state.selection.start != state.selection.end));
    }
}
add("integer", (argument) => new Handler(argument?.[0] ?? {}));
//# sourceMappingURL=integer.js.map